export default __webpack_public_path__ + "static/media/ban2.03c42404.png";